import React, { useEffect, useState } from "react";
import styles from "./SubProjectsNew.module.scss";
import Subproject from "./Subproject";
import { connect } from "react-redux";
import { getSubProjectBudgets } from "../../../store/actions";
const SubProjectsNew = ({
  item = {},
  opened,
  onClick,
  fromPage,
  isPostulationAllowed,
  isPostulating,
  allowOpen,
  type,
  dashboardView,
  itemButtonText,
  showRubrosWhenClosed,
  getSubProjectBudgets,
  subProjectBudgetsToSend,
  ...props
}) => {
  const [subProjectBudgets, setSubProjectBudgets] = useState([]);
  const dsa = type || "subproyecto";
  // const [openItem, setOpenItem] = useState(false)
  const isAllowed = item.status === "ALLOWED" ? true : false;

  return (
    <div
      className={allowOpen ? styles.subprojectView_open : styles.subprojectView}
    >
      {item[dsa] && item[dsa].length
        ? item[dsa].map((subProject, index) => {

            return (
              <div
                key={subProject.id}
                className={`${styles.subProjects} ${
                  fromPage && styles.fromPage
                }`}
              >
                <Subproject
                  {...props}
                  opened={opened}
                  allowOpen={allowOpen}
                  item={subProject}
                  fromPage={fromPage}
                  onClick={onClick}
                  type={type}
                  isPostulating={isPostulating}
                  isAllowed={isAllowed}
                  count={index + 1}
                  key={subProject.id}
                  isPostulationAllowed={isPostulationAllowed}
                  mainProject={item}
                  subProjectBudgets={subProjectBudgets}
                />
              </div>
            );
          })
        : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
  };
}

export default connect(mapStateToProps, { getSubProjectBudgets })(SubProjectsNew);
